import SettingsIcon from '@mui/icons-material/Settings';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import actions, { selectors } from '../../modules/cookies';
import messages from './messages';

interface ICookieSettingsButton {
  floating?: boolean;
  iconColor?: string;
  tooltipPlacement?: TooltipProps['placement'];
}

function CookieSettingsButton({
  floating = false,
  iconColor = '#819AAD',
  tooltipPlacement = 'left',
}: ICookieSettingsButton) {
  const dispatch = useDispatch();
  const isCookieConsentOpen = useSelector(selectors.getIsCookieSettingsOpen);

  return (
    <Box
      sx={
        floating
          ? {
              bottom: 16,
              position: 'fixed',
              right: 16,
              zIndex: 10000,
            }
          : {}
      }
    >
      <Tooltip placement={tooltipPlacement} title={<FormattedMessage {...messages.cookieSettingsButtonTooltip} />}>
        <Box sx={{ color: iconColor }}>
          <IconButton onClick={() => dispatch(actions.setCookieSettingsOpen(!isCookieConsentOpen))} size="small">
            <SettingsIcon />
          </IconButton>
        </Box>
      </Tooltip>
    </Box>
  );
}

export default CookieSettingsButton;
